import { Grid, Typography, makeStyles, } from '@material-ui/core';
import React, { useContext } from 'react';
import StoryContext from '../../contexts/StoryContext';
import SubquestionBox from '../SubquestionBox';
import PerformanceQuadrant from './PerformanceQuadrant';
import ErrorBoundary from '../ErrorBoundary';
import MessageBox from '../MessageBox';

function Q2Row2() {
  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    }
  }))();

  return (
    <SubquestionBox color={lightColor}>
      <Grid
        spacing={2}
        container
        direction="row"
        justify="center"
        alignItems="center"
      >

        <Grid item xs={12}>
          <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
            Age of Housing And Blood Lead Level Testing Rates, By County
          </Typography>
        </Grid>
        <Grid item xs={10} sm={6}>
          <MessageBox>
            <Typography variant="body1" align="left" gutterBottom>
              This chart compares the percentage of old homes in a county (horizontal) to the percentage of children getting tested for lead (vertical).

            </Typography>
            <Typography variant="body1" align="left" gutterBottom>
              In areas with a high percentage of older homes and a low rate of testing (lower right corner, in red), elevated blood lead levels in children may go undetected.

            </Typography>
            <Typography variant="body1" align="left">
              Click on a county to learn more about age of housing and testing rates.

            </Typography>
          </MessageBox>
        </Grid>
        <Grid item xs={12}>
          <ErrorBoundary>
            <PerformanceQuadrant />
          </ErrorBoundary>
        </Grid>
      </Grid>
    </SubquestionBox>
  );
}

export default Q2Row2;
